export default __webpack_public_path__ + "static/media/thump_up.41bf6c13.svg";